import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Link } from 'react-router-dom';
import { DISCLAIMER } from '@/constants/testIds/healthspan';

const ACK_KEY = 'telogenis_disclaimer_ack_v1';

export default function FirstVisitDisclaimerModal() {
  const [open, setOpen] = useState(false);
  const [ack, setAck] = useState(false);

  useEffect(() => {
    const acked = localStorage.getItem(ACK_KEY);
    if (!acked) setOpen(true);
  }, []);

  const handleAck = () => {
    if (!ack) return;
    localStorage.setItem(ACK_KEY, new Date().toISOString());
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v && ack) setOpen(false); }}>
      <DialogContent data-testid={DISCLAIMER.modal} className="max-w-[680px] p-0 overflow-hidden border-[color:var(--border-color)] bg-[color:var(--surface)]" onPointerDownOutside={(e)=>e.preventDefault()} onEscapeKeyDown={(e)=>e.preventDefault()}>
        <DialogHeader className="px-6 pt-6 pb-3 border-b border-[color:var(--border-color)]">
          <DialogTitle className="text-lg sm:text-xl tracking-tight">Before you continue — important notice</DialogTitle>
          <DialogDescription className="text-sm text-[color:var(--muted-fg)]">
            Telogenis is a research-information tool, not a medical service.
          </DialogDescription>
        </DialogHeader>
        <div className="px-6 py-5 space-y-3 text-sm leading-6 text-[color:var(--fg)]">
          <p>
            The Healthspan Optimization Engine summarises published longevity literature and links to primary sources. It does <strong>not</strong> diagnose, treat, cure, or prevent any disease, and it does not replace consultation with a qualified clinician.
          </p>
          <p>
            Any biomarker-driven suggestions are informational ranking outputs based on user-entered values. They are not personalised medical advice. Always discuss meaningful health changes with a licensed healthcare professional.
          </p>
          <p className="text-xs text-[color:var(--muted-fg)]">
            Read the <Link to="/legal/disclaimer" data-testid={DISCLAIMER.viewFullLink} className="underline underline-offset-4 text-[color:var(--accent-teal)]">full disclaimer</Link>.
          </p>
        </div>
        <DialogFooter className="px-6 py-5 border-t border-[color:var(--border-color)] bg-[color:var(--surface-2)] flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <label className="flex items-start gap-2 text-sm cursor-pointer">
            <Checkbox data-testid={DISCLAIMER.ackCheckbox} checked={ack} onCheckedChange={(v) => setAck(!!v)} className="mt-0.5" />
            <span>I understand this tool does not provide medical advice.</span>
          </label>
          <Button data-testid={DISCLAIMER.ackButton} disabled={!ack} onClick={handleAck} className="bg-[color:var(--brand-primary)] text-[color:var(--brand-primary-fg)] hover:bg-[color:var(--brand-primary-2)] disabled:opacity-50">
            Acknowledge and continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
